import { postJson } from '#/utils/http/postJson';

export async function apiSaveInterestFormMovement(
  payload: Partial<{
    firstName: string;
    lastName: string;
    email: string;
    aboutYourself: string;
    phone: string;
    linkedinUrl: string;
    gRecaptchaResponse: unknown;
    // location
    locationText: string | null;
    stateCode: string | null;
    countryCode: string | null;
    latitude: number | null;
    longitude: number | null;
  }>,
) {
  await postJson('/data/website/interest-forms/movement', payload);
}
